import { Component, OnDestroy, computed, inject } from '@angular/core';
import { ActivationEnd, Event, EventType, Router } from '@angular/router';
import { TrackingService } from '@bmng/services/tracking/tracking.service';
import { Subscription, filter } from 'rxjs';

import { toSignal } from '@angular/core/rxjs-interop';
import { ContextService } from '@bmng/services/context/context.service';
import { NavigationResult } from './core/services/navigation/routing-navigator.interface';
import { StackableRoutingNavigatorService } from './core/services/navigation/stackable-routing-navigator.service';
import { ScriptSecurityService } from './core/services/script-security/script-security.service';
import { PylonChatService } from './core/services/pylon-chat/pylon-chat.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: [ './app.component.scss' ],
    standalone: false,
})
export class AppComponent implements OnDestroy {
    private contextService = inject(ContextService);
    private pylonChatService = inject(PylonChatService);

    private subscription: Subscription =  new Subscription();

    activeRouterLevel: number = 0;

    hotelId: string;

    private readonly context = toSignal(this.contextService.context.asObservable());
    readonly cssVars = computed(() => this.context().branding?.cssVars || {});

    constructor(
        private navService: StackableRoutingNavigatorService,
        private router: Router,
        private trackingService: TrackingService,
    ) {
        inject(ScriptSecurityService);

        this.subscription.add(
            this.router.events.pipe(
                filter((event: Event) => event.type === EventType.ActivationEnd),
                filter((event: ActivationEnd) => !event.snapshot.routeConfig.children?.length),
            ).subscribe((event: ActivationEnd) => {
                const contextParams = ContextService.getContextParams(event.snapshot);
                const isHotel = contextParams.type === 'hotel';

                if (isHotel) {
                    this.hotelId = ContextService.getContextParams(event.snapshot).id;
                } else {
                    this.hotelId = null;
                }

                this.pylonChatService.updateForRoute(event.snapshot);
            }),
        );

        this.subscription.add(
            this.navService.getActiveStackLevel().subscribe((result: NavigationResult) => {
                this.activeRouterLevel = result[0];
            }),
        );

        this.subscription.add(
            this.router.events.subscribe((event: Event) => {
                this.trackingService.trackNavigationEvent(event);
            }),
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
